import axios from 'axios'
import userToken from '../redux/userToken'

// The Auth0 client runs refresh-token ROTATION with 10s leeway. Two refreshes in
// flight at the same time therefore present the same token twice, Auth0 reads
// that as token reuse, and it revokes the ENTIRE family — logging the operator
// out on every device at once rather than just failing one call.
//
// This app had two independent callers: session hydration (isLogged) and the
// 401 interceptor (axios-auth-refresh). axios-auth-refresh dedupes only within
// its own instance, so the two could race on boot. On 2026-09-17 that race,
// amplified by a render loop, took the warehouse floor down: failed refresh
// exchanges went from ~50/hour to 284/hour.
//
// One in-flight request, shared by every caller. Cleared on settle so the next
// refresh starts fresh.
let inFlight = null

export const refreshSession = () => {
  if (inFlight) return inFlight

  inFlight = axios
    .post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user/refresh_token`, {}, { withCredentials: true })
    .then(res => {
      userToken.token = res.data.token
      return res.data.token
    })
    .finally(() => {
      inFlight = null
    })

  return inFlight
}

// Test seam: the module-level promise outlives an individual example.
export const __resetRefreshSession = () => {
  inFlight = null
}

export default refreshSession
